
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"19","height":"19","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.5 0C4.256 0 0 4.256 0 9.5S4.256 19 9.5 19 19 14.744 19 9.5 14.744 0 9.5 0z","fill":"#32DF00"}}),_c('path',{attrs:{"d":"M14.214 5.106a.5.5 0 00-.709-.001l-5.693 5.694a.3.3 0 01-.424 0L5.493 8.912a.5.5 0 00-.707 0l-.633.633a.5.5 0 000 .708l3.093 3.092a.5.5 0 00.707 0l6.894-6.894a.5.5 0 00.002-.706l-.635-.639z","fill":"#fff"}})])
          )
        }
      }
    